import React from "react";
import useTranslation from "@hooks/use_translation";
import type { GhrTask } from "@/types/task";
import TaskCard from "./TaskCard";
import JobInfo from "./JobInfo";
import GHR_TASK_CONFIG from "@/config/ghr_task_config";

interface TaskCardProps {
  task: GhrTask;
}

const TakeHomeTest: React.FC<TaskCardProps> = ({ task }) => {
  const { t } = useTranslation("tasks");
  const isThirdParty = !task.url;
  const config = isThirdParty
    ? GHR_TASK_CONFIG.ThirdPartyTakeHomeTest
    : GHR_TASK_CONFIG.TakeHomeTest;

  return (
    <TaskCard
      icon={config.icon}
      task={task}
      title={t(config.titleKey)}
      body={<JobInfo task={task} />}
      helpText={isThirdParty ? t("takeHomeTest.third_party_help_text") : undefined}
      actionHref={task.url || undefined}
      actionText={t(config.actionTextKey)}
      dismissable={false}
      theme={{
        colors: {
          background: "bg-white",
          border: "border-gray-700",
          iconBackground: "bg-gray-500",
        },
      }}
    />
  );
};

export default TakeHomeTest;
